import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    checkIsClear: 'It’s clear and all the information is readable',
    checkMessage:
      'Please help us validate your account faster by checking your document one last time',
  },
  fr: {
    checkIsClear: 'Votre document est net et lisible',
    checkMessage:
      'Pour nous aider à valider votre compte plus rapidement, prenez quelques minutes pour vérifier une dernière fois votre document.',
  },
});
